import config from '../../../config';

export function conditionUpload(file) {
    return (file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png') && file.size < config.sizeFileUploadAvatar;
}
